import BusinessStepsFlow from './BusinessStepsFlow'
import type { BusinessStep } from './types'
import type { ProcedurePresentation } from '@/frontend/features/AgentChats/events/agentEvents'

// The workflow is the heart of the process, so it is the first component of
// the show page: each step renders as its own card in a centered column.
export default function ProcessWorkflowSection({
  steps,
  draftPreview,
}: {
  steps: BusinessStep[]
  draftPreview?: ProcedurePresentation | null
}) {
  const previewSteps = draftPreview?.draft?.fields.steps
  const displayedSteps: BusinessStep[] = previewSteps?.length
    ? previewSteps.map((step) => ({ ...step, detail: step.detail ?? '' }))
    : steps

  return (
    <section className="space-y-3">
      <div className="flex items-center gap-2">
        <h2 className="text-lg font-semibold">Etapas do processo</h2>
        {previewSteps?.length ? (
          <span className="rounded-full border border-agent/20 bg-agent-soft px-2 py-0.5 text-[10.5px] font-medium text-agent">
            Prévia não aplicada
          </span>
        ) : null}
      </div>
      <BusinessStepsFlow steps={displayedSteps} />
    </section>
  )
}
